import { composeIO } from 'react-compose-io'
import { tabelaDetalheControleComissaoPedidoIO } from './TabelaDetalheControleComissaoPedido.IO'
import { TabelaDetalheControleComissaoPedidoView } from './TabelaDetalheControleComissaoPedido.View'

export const TabelaDetalheControleComissaoPedido = composeIO(TabelaDetalheControleComissaoPedidoView, tabelaDetalheControleComissaoPedidoIO)
